import React from "react";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import Header from "../components/Layout/Header";
import Footer from "../components/Layout/Footer";
import Loader from "../components/Layout/Loader";
import ServiceCard from "../components/Services/ServiceCard";
import { server } from "../server";

const ServicesPage = () => {
  const [services, setServices] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const INITIAL_VISIBLE = 20;
  const LOAD_MORE_STEP = 20;
  const [visibleCount, setVisibleCount] = useState(INITIAL_VISIBLE);

  useEffect(() => {
    const loadServices = async () => {
      try {
        setIsLoading(true);
        const { data } = await axios.get(`${server}/service/get-all-events`);
        setServices(data?.events || []);
      } catch {
        setServices([]);
      } finally {
        setIsLoading(false);
      }
    };
    loadServices();
  }, []);

  const activeServices = (services || [])
    .filter((item) => {
      if (item.status && item.status !== "active") return false;
      if (item.approvedEnd) {
        const end = new Date(item.approvedEnd);
        if (end < new Date()) return false;
      }
      return true;
    })
    .sort((a, b) => new Date(b.createdAt || 0) - new Date(a.createdAt || 0));

  useEffect(() => {
    setVisibleCount(INITIAL_VISIBLE);
  }, [activeServices.length]);

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <div>
          <Header activeHeading="/services" />
          <div className="bg-[#CCBEA1] border-t border-t-black" id="inner-page-banner">
            <div className="py-[50px] px-4 text-center">
              <h1 className="lg:text-4xl text-3xl font-semibold">Services</h1>
              <p>Home &gt; <span className="text-[#38513B]">Services</span></p>
            </div>
          </div>

          <div className="w-11/12 mx-auto py-6">
            <div className="mb-6 rounded-xl border border-slate-200 bg-[#f8faf9] p-5 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
              <div>
                <h2 className="text-xl font-semibold text-slate-900">Promote Your Services</h2>
                <p className="text-sm text-slate-600 mt-1">
                  Showcase your services to more customers and grow your reach with a featured service listing.
                </p>
              </div>
              <Link
                to="/profile/create-service"
                className="inline-flex items-center justify-center rounded-lg bg-[#38513b] px-5 py-2.5 text-sm font-medium text-white shadow-sm hover:bg-[#2f4232] transition"
              >
                Advertise Services
              </Link>
            </div>

            {activeServices.length ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
                {activeServices.slice(0, visibleCount).map((service) => (
                  <ServiceCard key={service._id || service.id} data={service} />
                ))}
              </div>
            ) : (
              <p>No services available.</p>
            )}
            {activeServices.length > visibleCount && (
              <div className="flex justify-center mt-6">
                <button
                  type="button"
                  onClick={() => setVisibleCount((prev) => prev + LOAD_MORE_STEP)}
                  className="rounded-lg bg-[#38513b] px-5 py-2 text-sm font-medium text-white hover:bg-[#2f4232]"
                >
                  Load more services
                </button>
              </div>
            )}
          </div>

          <Footer />
        </div>
      )}
    </>
  );
};

export default ServicesPage;
